import { render, staticRenderFns } from "./BmsWidget.vue?vue&type=template&id=0c75acaf&scoped=true&"
import script from "./BmsWidget.vue?vue&type=script&lang=js&"
export * from "./BmsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75acaf",
  null
  
)

export default component.exports